import RankingClientes from './RankingClientes'

export default function RankingVendedores() {
  return <RankingClientes tipo="vendedores" titulo="Ranking de Vendedores" tituloRelatorio="RELAÇÃO DE VENDEDORES" />
}
